import * as React from 'react';
import './index.scss';
import { AreaInfo, RankItem, EliminateRankRsp } from '@pubts/fetch.ts';
import { None, WebAnchorItem, WithPage, WebAnchorItemDesc } from '@huyafed/comp'
interface Props extends AreaInfo {
  data: EliminateRankRsp,
  id: string,
  sMatchDescFh: string,
  sMatchDescTt: string,
}

const Rank2: React.FC<Props> = props => (
  <div className={`rank2 area-${props.id}`}>
    <p className='rank-desc'>{props.id === 'tt' ? props.sMatchDescTt : props.sMatchDescFh}</p>
    <WebAnchorItemDesc
      width={860}
      color="#f6d94a"
      descs={['排名', '主播昵称', '总里程']}
    />
    <div className='rank-List'>
      {
        props.data.length === 0 ?
          <None text={'暂无数据'} />
          :
          props.data.map((item: RankItem, idx: number) => (

            <WebAnchorItem
              width={870}
              canJump={true}
              isLarge={true}
              color={'#ffffff'}
              borderColor={'#0f257e'}
              key={idx}
              msg={{ ...item, tJump: { ...item.tJump, bIsLive: item.tJump.iIsLive }, sNickName: item.sNickName, sLogoUrl: item.sLogoUrl }}
            />
          ))
      }
      {props.children}
    </div>
  </div>
)
export default WithPage(Rank2);